import MaterialBuilder from "../../rendering/material-builder";
import AssetLibrary from "../../assets/asset-library";
import getIndexAttribute from "../../utils/get-index-attribute";

function createSpaceFilling(molecules, colorScheme, radii) {
    const meshes = [], cache = {};
    const tmp = new THREE.Vector3(), offsetVector = new THREE.Vector3();

    molecules.forEach(molecule => {
        if (molecule.length === 0) return;

        const geometry = new THREE.BufferGeometry();
        const indices = [], positions = [], normals = [], uvs = [];

        let offsetVertex = 0, offsetIndex = 0;

        const groupedMolecules = molecule.reduce((groups, atom) => {
            const group = groups[atom.elem] = groups[atom.elem] || [];

            group.push(atom);

            return groups;
        }, {});

        Object.keys(groupedMolecules).forEach((element, groupIndex) => {
            const group = groupedMolecules[element], groupBeginIndex = offsetIndex;
            const atomColors = element in colorScheme ? colorScheme[element] : colorScheme.default;

            const { geometry: geometryCylinder } = element in cache
                ? cache[element]
                : (cache[element] = {
                    groupIndex,
                    material: MaterialBuilder.build({
                        color: atomColors.atom,
                        side: THREE.DoubleSide,
                        envMap: AssetLibrary.envLight.activeMap
                    }),
                    geometry: new THREE.SphereBufferGeometry(
                        (element in radii
                            ? radii[element]
                            : radii.default) * 0.02,
                        32, 32)
                });

            const attrPosition = geometryCylinder.getAttribute("position");
            const attrNormal = geometryCylinder.getAttribute("normal");
            const attrUv = geometryCylinder.getAttribute("uv");
            const attrIndices = geometryCylinder.index;
            const countIndex = attrIndices.count;
            const countVertex = attrPosition.count;

            group.forEach(atom => {
                offsetVector.set(atom.x, atom.y, atom.z);

                for (let bi = 0; bi < countIndex; bi++)
                    indices.push(attrIndices.array[bi] + offsetVertex);

                for (let bi = 0; bi < countVertex; bi++) {
                    const inormal = bi * attrNormal.itemSize;
                    const iuv = bi * attrUv.itemSize;

                    tmp
                        .fromArray(attrPosition.array, attrPosition.itemSize * bi)
                        .add(offsetVector);
                    positions.push(tmp.x, tmp.y, tmp.z);

                    normals.push(attrNormal.array[inormal], attrNormal.array[inormal + 1], attrNormal.array[inormal + 2]);
                    uvs.push(attrUv.array[iuv], attrUv.array[iuv + 1]);
                }

                offsetVertex = offsetVertex + countVertex;
                offsetIndex = offsetIndex + countIndex;
            });

            geometry.addGroup(groupBeginIndex, offsetIndex - groupBeginIndex, groupIndex);
        });

        const ConstructorIndex = getIndexAttribute(indices.length);

        const attrPosition = new THREE.Float32BufferAttribute(positions, 3);
        const attrNormal = new THREE.Float32BufferAttribute(normals, 3);
        const attrUv = new THREE.Float32BufferAttribute(uvs, 2);
        const attrIndices = new ConstructorIndex(indices, 1);

        geometry.setIndex(attrIndices);
        geometry.addAttribute("position", attrPosition);
        geometry.addAttribute("normal", attrNormal);
        geometry.addAttribute("uv", attrUv);

        const material = Object
            .values(cache)
            .sort((a, b) => a.groupIndex - b.groupIndex)
            .map(({ material }) => material);

        meshes.push({ geometry, material, name: "Compound" });
    });

    return meshes;
}

export default createSpaceFilling;
export { createSpaceFilling };